import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';
import { UserVideoStylePopup } from '../../../Utils/redirections';
import dynamic from 'next/dynamic';
import {
  fireDiscardPopupEvent,
  fireVedioActionEvent,
  fireViewedPopupEvent,
  getVedioID,
} from '../../Product/ImageGallaryCarousel/utils';

const Modal = dynamic(() => import('react-modal'), {
  ssr: false,
});
const VideoModal = dynamic(() => import('./VideoModal'), {
  ssr: false,
});

export default function VideoReviewPopup({
  showPopup,
  videoData,
  setShowPopup,
  paramsAdd,
  autoPlay,
  product,
  videoUrl,
  parent,
  increaseRatio,
}) {
  const youTubePopup = useRef(null);
  const router = useRouter();

  const closeModal = () => {
    setShowPopup(false);

    const params = new URLSearchParams(window.location.search);
    params.delete(paramsAdd);
    router.back();
  };
  useEffect(() => {
    if (showPopup) fireViewedPopupEvent(product, parent);
  }, [showPopup]);

  useEffect(() => {
    router.beforePopState(() => {
      setShowPopup(false);
      return true;
    });
  }, []);

  // useRouterChangeStart(closeOnBackClick);
  const CenterPopup = UserVideoStylePopup('50%', 'auto', 'auto', '50%');
  const player1 = useRef(null);

  const youtubeApiHandler = () => {
    const tag = document.createElement('script');
    const autoplay = autoPlay;
    tag.src = 'https://www.youtube.com/iframe_api';
    tag.onload = onYouTubeIframeAPIReady;
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    function onYouTubeIframeAPIReady() {
      window.YT.ready(() => {
        player1.current = new YT.Player('yt-player', {
          events: {
            onReady: onPlayerReady,
            onStateChange: onPlayerStateChange,
          },
        });
      });
    }

    function onPlayerReady(event) {
      if (autoplay === 1) {
        event.target.playVideo();
        // fireVedioActionEvent(
        //     product,
        //     1,
        //     getVedioID(videoUrl),
        //     autoPlay,
        // );
      }
    }

    function onPlayerStateChange(event) {
      // -1 – unstarted
      // 0 – ended
      // 1 – playing
      // 2 – paused
      // 3 – buffering
      // 5 – video cued
      if (event.data == 0) {
        player1.current.stopVideo(); // for not showing related and Suggested vedios after vedio ends..
      } else if (event.data === 2) {
        player1.current.pauseVideo();
        fireVedioActionEvent(
          product,
          event.data,
          getVedioID(videoUrl),
          autoplay,
        );
      } else if (event.data === 1) {
        fireVedioActionEvent(
          product,
          event.data,
          getVedioID(videoUrl),
          autoplay,
        );
      }
    }
  };

  const modalProps = {
    youtubeApiHandler,
    closeModal,
    videoData,
    autoPlay,
    increaseRatio,
  };
  return showPopup ? (
    <Modal
      isOpen={showPopup}
      onRequestClose={closeModal}
      style={CenterPopup}
      appElement={youTubePopup.current}
      ariaHideApp={false}
      onAfterClose={() => {
        fireDiscardPopupEvent(product, parent);
      }}
    >
      <VideoModal {...modalProps} />
    </Modal>
  ) : null;
}
